module.exports = __webpack_public_path__ + "img/web_coaches_top@3x.4cddc24b.jpg";